namespace app.configuracoes {

    import Properties = app.support.constants.Properties;

    export interface IConfiguration {
        id: string;
        stateName: string;
        translation: string;
        url: string;
        src: string;
        icon: string;
    }

    export class ConfiguracoesService {

        private configuracoesPromise: ng.IPromise<IConfiguration[]>;
        
        /** @ngInject */
        public constructor(private $rootScope: ng.IRootScopeService, private $http: ng.IHttpService,
                private properties: app.support.constants.Properties, private toolbarService: app.toolbar.ToolbarService) {

        }
        
        public carregarConfiguracoes(): ng.IPromise<IConfiguration[]> {
            if (!this.configuracoesPromise) {
                this.configuracoesPromise = this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/configurations")
                        .then((response: ng.IHttpPromiseCallbackArg<IConfiguration[]>) => {
                                response.data
                                .forEach(configuration => this.addConfigurationToNavigation(configuration));
                                return response.data;
                });
            }
            return this.configuracoesPromise;
        }

        public resetConfiguracoes(): void {
            this.configuracoesPromise = null;
            this.toolbarService.clearConfigurations();
        }

        private addConfigurationToNavigation(configuration: IConfiguration): void {
            this.toolbarService.pushConfiguration(configuration);
        }
        
    }

    angular.module("app.configuracoes")
            .service("app.configuracoes.ConfiguracoesService", ConfiguracoesService);

}